import { css } from '@emotion/css'
import { accessiblyHidden } from '../../utils/styleUtils'
import getThemeColors, { colors } from '../../themes'
import { borderRadius, fontFamily, fontSize, fontWeight, spacing } from '../../styles'

export const attachmentHeight = {
  small: 30,
  default: 35,
}

const styles = {
  wrapper: css({
    boxSizing: 'border-box',
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: borderRadius.default,
    fontSize: fontSize.small,
    fontFamily: fontFamily.body,
    lineHeight: 1,
    fontWeight: fontWeight.semiBold,
    maxWidth: '100%',

    '& > * + *': {
      marginLeft: spacing.small,
    },
  }),

  icon: css({
    background: 'none',
    border: 'none',
    padding: 0,
    margin: 0,
    lineHeight: 1,
    textDecoration: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),

  link: css({
    cursor: 'pointer',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    textDecoration: 'none',
    color: 'inherit',
  }),

  label: css({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  }),

  accessiblyHidden: css(accessiblyHidden),
}

export default styles

export const wrapperTheme = theme => {
  const themed = getThemeColors(theme)

  // Light theme is a bit of a special case
  if (theme === 'light') {
    return css({
      backgroundColor: themed.light,
      color: colors.jumbo,

      '&:hover': {
        backgroundColor: themed.medium,
        color: colors.jumbo,
      },
    })
  }

  return css({
    backgroundColor: themed.light,
    color: themed.base,

    '&:hover': {
      backgroundColor: themed.base,
      color: colors.white,

      '& svg path': {
        fill: colors.white,
      },
    },
  })
}

export const wrapperSize = size => {
  switch (size) {
    case 'small':
      return css({
        height: attachmentHeight.small,
        paddingLeft: spacing.default,
        paddingRight: spacing.small,
      })

    default:
      return css({
        height: attachmentHeight.default,
        paddingLeft: spacing.default,
        paddingRight: spacing.small,
      })
  }
}

export const labelSize = size => {
  switch (size) {
    case 'small':
      return css({
        marginRight: spacing.small,
      })

    default:
      return css({
        marginRight: spacing.default,
      })
  }
}

export const iconColor = theme => {
  // Light theme is a special case
  if (theme === 'light') return colors.jumbo

  const themed = getThemeColors(theme)
  return themed.base
}

export const iconSize = size => {
  switch (size) {
    case 'small':
      return 16

    default:
      return 18
  }
}
